import {Component, Input, Output, OnInit, EventEmitter} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';

import {LpFundReqRes} from '../../../funds/LpFundReqRes.model';
import {LenderInformation} from '../../../../shared/models/LenderInformation.model';
import {CurrencyModel} from '../../../../shared/models/CurrencyModel';
import {LenderInfoDialogComponent, LenderInfoDialogModel} from '../../../shared/holdings/lender-info-dialog/lender-info-dialog.component';
import InvestmentType from 'src/app/shared/enums/InvestmentType.enum';
import {LpAssetReqRes} from '../../../assets/LpAssetReqRes.model';
import {HoldingDiscriminator} from '../../../../shared/enums/HoldingDiscriminator.enum';
import InvestmentSecurityType from '../../../../shared/enums/InvestmentSecurityType.enum';
import {
  LenderJuniorInfoDialogComponent,
  LenderJuniorInfoDialogModel
} from '../../../shared/holdings/lender-junior-info-dialog/lender-junior-info-dialog.component';
import { isNullOrUndefined } from 'src/app/shared/TerraUtils';

@Component({
  selector: 'terra-holding-capital-information',
  templateUrl: './holding-capital-information.component.html',
  styleUrls: ['./holding-capital-information.component.scss', '../../../styles/holding/holding-page-shared.scss']
})
export class HoldingCapitalInformationComponent implements OnInit {
  @Input() holding: LpFundReqRes | LpAssetReqRes;
  @Input() isPhonePreview = false;
  @Output() toDisplay = new EventEmitter<boolean>();
  holdingDiscriminator: HoldingDiscriminator;
  holdingAsAsset: LpAssetReqRes;
  holdingAsFund: LpFundReqRes;

  // Enums
  InvestmentType = InvestmentType;
  SecurityType = InvestmentSecurityType;
  HoldingDiscriminator = HoldingDiscriminator;

  constructor(private matDialog: MatDialog) {
  }

  ngOnInit() {
    this.holdingDiscriminator = this.holding.discriminator;
    this.holdingAsAsset = this.holding as LpAssetReqRes;
    this.holdingAsFund = this.holding as LpFundReqRes;
    this.displayData();
  }

  showLenderInfoDialog(lenderInfo: LenderInformation, currency: CurrencyModel, estimatedMarketValue, totalCost) {
    const dialogConfig = new MatDialogConfig<LenderInfoDialogModel>();
    this.setDialogConfigProperties(dialogConfig, lenderInfo, currency, estimatedMarketValue, totalCost);
    this.matDialog.open(LenderInfoDialogComponent, dialogConfig);
  }

  showLenderJuniorInfoDialog(lenderInfo: LenderInformation, currency: CurrencyModel, estimatedMarketValue, totalCost) {
    const dialogConfig = new MatDialogConfig<LenderJuniorInfoDialogModel>();
    this.setDialogConfigProperties(dialogConfig, lenderInfo, currency, estimatedMarketValue, totalCost);
    this.matDialog.open(LenderJuniorInfoDialogComponent, dialogConfig);
  }

  private setDialogConfigProperties(dialogConfig: MatDialogConfig, lenderInfo: LenderInformation, currency: CurrencyModel, estimatedMarketValue, totalCost): void {
    dialogConfig.disableClose = false;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '100vw';
    dialogConfig.maxWidth = '600px';
    dialogConfig.height = '100vh';
    dialogConfig.maxHeight = '800px';
    dialogConfig.panelClass = this.isPhonePreview ? 'info-dialog-no-shadow' : 'info-dialog';

    const data = new LenderInfoDialogModel();
    data.lenderInformation = lenderInfo;
    data.currency = currency;
    data.estimatedMarketValue = estimatedMarketValue;
    data.totalCost = totalCost;
    data.initialSecurityType = (this.holding as LpAssetReqRes).initialSecurityType;
    dialogConfig.data = data;
  }

  displayData(): void {
    this.toDisplay.next(!isNullOrUndefined(this.holding.totalCapitalization) || !isNullOrUndefined(this.holding.lenderInformation?.amount) ||
                     !isNullOrUndefined(this.holding.lenderInformation?.amountJunior) || !isNullOrUndefined(this.holding.totalInvestorEquity) ||
                     !isNullOrUndefined(this.holding.gpEquityFromTotalEquity) || !isNullOrUndefined(this.holding.totalEquityInvestedToDate) ||
                     !isNullOrUndefined(this.holding.totalReturnsToDate) || !isNullOrUndefined(this.holding.estimatedMarketValue) ||
                     !isNullOrUndefined((this.holding as LpAssetReqRes).actualCostsToDate) || !isNullOrUndefined((this.holding as LpAssetReqRes).outstandingLoanAmountToDate));
  }
}
